export const TIPOS_DOCUMENTO = {
  DNI: 'DNI',
  PASAPORTE: 'PASAPORTE'
};